module.exports = __webpack_public_path__ + "img/player-repeat.421388aa.svg";